import { baseColors, basePadding } from "@Constants/baseStyles"
import { arrayOfColors } from "@Constants/constant"
import { randomColor } from "@Utils/utils"
import { StyleSheet } from "react-native"
import { RFValue } from "react-native-responsive-fontsize"

const styles = StyleSheet.create({
    container: {
        flex: 1,
        borderRadius: RFValue(20),
        backgroundColor: baseColors.white
    },
    contentContainer: { paddingVertical: basePadding.paddingVertical, paddingBottom: 100 },
    title: { color: randomColor(arrayOfColors).textColor, marginTop: RFValue(12), marginBottom: RFValue(20) }
})

export default styles
